var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-string-typer",class:{ 'is-cursor-hidden': _vm.hideCursor }},[_vm._v(_vm._s(_vm.currentText))])}
var staticRenderFns = []

export { render, staticRenderFns }